import axios from 'axios';
import { useQuery } from 'react-query';
import request from '../../../../../../helpers/request';

const useStreetsQuery = createQuery('Request/streets', {
  errorMessage: 'Не удалось загрузить список улиц',
});

const useHousesQuery = createQuery('Request/streets_houses', {
  errorMessage: 'Не далось загрузить список домов',
});

const useRoomsQuery = createQuery('Request/houses_flats', {
  errorMessage: 'Не далось загрузить список помещений',
});

export { useStreetsQuery, useHousesQuery, useRoomsQuery };

const queryOptions = { notifyOnChangeProps: ['data', 'isFetching'] };

function mapEndPointToUrl({ endPoint, params }) {
  return { url: endPoint, params };
}

function createQuery(endPoint, options = {}) {
  const { errorMessage = '', createParams = mapEndPointToUrl } = options;

  const fetch = (params = {}, source) => {
    const { url, params: data } = createParams({ endPoint, params });
    return request.get(
      url,
      data,
      errorMessage,
      undefined,
      undefined,
      undefined,
      {
        cancelToken: source.token,
      }
    );
  };

  const cancelableFetch = (params) =>
    withCancelToken((source) => fetch(params, source));

  const useFetch = ({ params = {}, options }) => {
    return useQuery(
      [endPoint, ...Object.values(params)],
      () => cancelableFetch(params),
      {
        ...queryOptions,
        ...options,
      }
    );
  };

  return useFetch;
}

function withCancelToken(fn) {
  const source = axios.CancelToken.source();
  const promise = fn(source);

  promise.cancel = () => {
    source.cancel();
  };

  return promise;
}
